import type { HeldRole } from 'tio-employee/services/session-context';

/**
 * Relationship types that may view partner reporting.
 */
export const REPORTING_ROLES = ['TIO_ADMIN', 'EMPLOYEE_ADMIN', 'ACCOUNT_OWNER'];

/**
 * The company the reporting subtree may scope to, or undefined when reporting is
 * not viewable for the company the session is acting within.
 *
 * Only reporting roles are considered. A session can be acting at a company it
 * holds nothing but PARTICIPANT at, and reports there would hand over data it has
 * no role to see; the guard denies instead, and the company switcher is the way
 * across.
 *
 * @param heldRoles every role the session holds, with the companies it holds them at
 * @param companyId the company the session is acting within
 * @returns companyId when reportable, otherwise undefined
 */
export function reportingCompanyId(
  heldRoles: HeldRole[],
  companyId: string | undefined
): string | undefined {
  if (!companyId) return undefined;

  const reportable = heldRoles.some(
    (role) => REPORTING_ROLES.includes(role.relationshipType) && role.companyIds.includes(companyId)
  );
  return reportable ? companyId : undefined;
}
